import styled from 'styled-components';
import { Container as MenuItemContainer } from "../MenuItem/MenuItem.styles";
export const Container = styled.div``;
export const LabelContainer = styled.div`
  display: ${_ref => {
  let {
    hasLabel
  } = _ref;
  return hasLabel ? 'flex' : 'none';
}};
  height: fit-content;
`;
export const ChildrenContainer = styled.div`
  & ${MenuItemContainer} {
    border-bottom: 1px solid ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.secondaryL1;
}};
    border-radius: 0;
  }

  & > ${MenuItemContainer}:first-child {
    border-radius: 10px 10px 0 0;
  }

  & > ${MenuItemContainer}:last-child {
    border-radius: 0 0 10px 10px;
    border-bottom: 0;
  }
`;
export const RightLabel = styled.p`
  ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fonts.labelMD;
}}
  color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.neutralL5;
}};
  margin: 0;
  margin-bottom: 12px;
  margin-left: auto;
`;
export const LeftLabel = styled(RightLabel)`
  margin-left: 0;
`;
export const Gutter = styled.div`
  height: ${_ref5 => {
  let {
    gutter
  } = _ref5;
  return gutter === 'sm' ? '12px' : gutter === 'md' ? '24px' : '40px';
}};
`;